{
    let close_btn = document.querySelector('.info-bar__close');

    if (close_btn !== null) {
        close_btn.addEventListener('click', e => {
            let parent = e.target.closest('.info-bar');
            parent.style.display = 'none';
        });
    }
}
